var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{on:{"change":function($event){_vm.changeSwitch()}},model:{value:(_vm.specEdit),callback:function ($$v) {_vm.specEdit=$$v},expression:"specEdit"}})}
var staticRenderFns = []

export { render, staticRenderFns }